import { SelectionAge, SelectionAny } from './internal';
export class SelectionSpouseEventDetails extends SelectionAny {
    getAge() {
        return this.get("AGE" /* Tag.Age */, null, SelectionAge);
    }
}
//# sourceMappingURL=SelectionSpouseEventDetails.js.map